import { render, staticRenderFns } from "./FilterExchange.vue?vue&type=template&id=106b528a&scoped=true"
import script from "./FilterExchange.vue?vue&type=script&lang=ts"
export * from "./FilterExchange.vue?vue&type=script&lang=ts"
import style0 from "./FilterExchange.vue?vue&type=style&index=0&id=106b528a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b528a",
  null
  
)

export default component.exports